
import { GridBehavior } from './GridBehavior.js';
import { TextBehavior, ImageBehavior, ButtonBehavior, InputBehavior, DataBindingBehavior } from './CoreBehaviors.jsx';
import { ContentSizeFitterBehavior } from './ContentSizeFitterBehavior.js';
import {
  AldooImageBehavior,
  AldooButtonBehavior,
  AldooInputBehavior,
  AldooCheckboxBehavior,
  AldooDropdownSelectBehavior,
  AldooMenuBehavior,
  AldooDataTableBehavior,
  AldooPanelBehavior,
  AldooProgressBarBehavior,
  AldooSpinnerBehavior,
  AldooTabsBehavior,
  AldooToggleSwitchBehavior,
  AldooTypographyBehavior,
  AldooDatePickerBehavior,
  AldooDateFilterDropdownBehavior,
  AldooDropZoneBehavior,
} from './AldooRABehaviors.jsx';

export const BEHAVIORS = {
  [GridBehavior.id]: GridBehavior,
  [TextBehavior.id]: TextBehavior,
  [ImageBehavior.id]: ImageBehavior,
  [ButtonBehavior.id]: ButtonBehavior,
  [InputBehavior.id]: InputBehavior,
  [DataBindingBehavior.id]: DataBindingBehavior,
  [ContentSizeFitterBehavior.id]: ContentSizeFitterBehavior,
  [AldooImageBehavior.id]: AldooImageBehavior,
  [AldooButtonBehavior.id]: AldooButtonBehavior,
  [AldooInputBehavior.id]: AldooInputBehavior,
  [AldooCheckboxBehavior.id]: AldooCheckboxBehavior,
  [AldooDropdownSelectBehavior.id]: AldooDropdownSelectBehavior,
  [AldooMenuBehavior.id]: AldooMenuBehavior,
  [AldooDataTableBehavior.id]: AldooDataTableBehavior,
  [AldooPanelBehavior.id]: AldooPanelBehavior,
  [AldooProgressBarBehavior.id]: AldooProgressBarBehavior,
  [AldooSpinnerBehavior.id]: AldooSpinnerBehavior,
  [AldooTabsBehavior.id]: AldooTabsBehavior,
  [AldooToggleSwitchBehavior.id]: AldooToggleSwitchBehavior,
  [AldooTypographyBehavior.id]: AldooTypographyBehavior,
  [AldooDatePickerBehavior.id]: AldooDatePickerBehavior,
  [AldooDateFilterDropdownBehavior.id]: AldooDateFilterDropdownBehavior,
  [AldooDropZoneBehavior.id]: AldooDropZoneBehavior,
};

export const getBehavior = (type) => {
  return BEHAVIORS[type];
};
